import React, { useState, useEffect } from 'react';
import {
  Button,
  Container,
  TextField,
  Table,
  Modal,
  TableBody,
  TableCell,
  Box,
  Typography,
  Paper,
  InputAdornment,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Tooltip,
  useTheme,
  styled,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  Search as SearchIcon,
  Close as CloseIcon,
  Visibility as ViewIcon,
  KeyboardDoubleArrowLeft as ChevronLeft,
  KeyboardDoubleArrowRight as ChevronRight,
  Add as AddIcon,
} from '@mui/icons-material';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useNavigate } from 'react-router-dom';

const CustomTableScrollbar = styled('div')(({ theme }) => ({
  '&::-webkit-scrollbar': {
    height: '6px',
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
  },
  scrollbarWidth: 'thin',
  scrollbarColor: `${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)'} transparent`,
}));

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const ManageCourseQuiz = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const rowsPerPageOptions = [5, 10, 25, 50];
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [showUserGuideModal, setShowUserGuideModal] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [searchTerm, setSearchTerm] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showAddQuizModal, setShowAddQuizModal] = useState(false);
  const [showEditQuizModal, setShowEditQuizModal] = useState(false);
  const [showViewQuizModal, setShowViewQuizModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successModalType, setSuccessModalType] = useState('add');
  const [selectedQuiz, setSelectedQuiz] = useState({ quizId: null, quizName: '' });
  const [formData, setFormData] = useState({
    viewResult: false,
    setTime: false,
    reAttempt: false,
    date: '',
    startTime: '',
    endTime: '',
    courseName: '',
    quizName: '',
    maxAttempts: '',
    duration: '',
    noOfQuestions: '',
    totalSingleChoose: '',
    totalMultipleChoose: '',
    totalTrueFalse: '',
    marksPerQuestion: '',
    passMarks: '',
    negativeMarking: '0',
  });

  // Static data for quizzes and courses
  const staticQuizData = [
    {
      quizId: 1,
      quizName: 'General Knowledge Quiz',
      duration: '30',
      numberOfQuestions: 20,
      courseName: 'Mathematics',
      viewResult: true,
      setTime: false,
      reAttempt: true,
      date: '',
      startTime: '',
      endTime: '',
      maxAttempts: '2',
      totalSingleChoose: '10',
      totalMultipleChoose: '5',
      totalTrueFalse: '5',
      marksPerQuestion: '1',
      passMarks: '10',
      negativeMarking: '0',
    },
    {
      quizId: 2,
      quizName: 'Science Quiz',
      duration: '45',
      numberOfQuestions: 30,
      courseName: 'Science',
      viewResult: false,
      setTime: true,
      reAttempt: false,
      date: '2025-09-01',
      startTime: '10:00',
      endTime: '11:00',
      maxAttempts: '1',
      totalSingleChoose: '15',
      totalMultipleChoose: '10',
      totalTrueFalse: '5',
      marksPerQuestion: '2',
      passMarks: '40',
      negativeMarking: '-1',
    },
    {
      quizId: 3,
      quizName: 'Math Quiz',
      duration: '60',
      numberOfQuestions: 25,
      courseName: 'Mathematics',
      viewResult: true,
      setTime: false,
      reAttempt: true,
      date: '',
      startTime: '',
      endTime: '',
      maxAttempts: '3',
      totalSingleChoose: '10',
      totalMultipleChoose: '10',
      totalTrueFalse: '5',
      marksPerQuestion: '1',
      passMarks: '15',
      negativeMarking: '0',
    },
    {
      quizId: 4,
      quizName: 'History Quiz',
      duration: '40',
      numberOfQuestions: 15,
      courseName: 'History',
      viewResult: false,
      setTime: true,
      reAttempt: false,
      date: '2025-09-02',
      startTime: '14:00',
      endTime: '15:00',
      maxAttempts: '1',
      totalSingleChoose: '5',
      totalMultipleChoose: '5',
      totalTrueFalse: '5',
      marksPerQuestion: '2',
      passMarks: '20',
      negativeMarking: '-1',
    },
    {
      quizId: 5,
      quizName: 'Geography Quiz',
      duration: '35',
      numberOfQuestions: 18,
      courseName: 'Geography',
      viewResult: true,
      setTime: false,
      reAttempt: true,
      date: '',
      startTime: '',
      endTime: '',
      maxAttempts: '2',
      totalSingleChoose: '8',
      totalMultipleChoose: '6',
      totalTrueFalse: '4',
      marksPerQuestion: '1',
      passMarks: '10',
      negativeMarking: '0',
    },
    {
      quizId: 6,
      quizName: 'Literature Quiz',
      duration: '50',
      numberOfQuestions: 22,
      courseName: 'Literature',
      viewResult: false,
      setTime: true,
      reAttempt: false,
      date: '2025-09-03',
      startTime: '09:00',
      endTime: '10:00',
      maxAttempts: '1',
      totalSingleChoose: '10',
      totalMultipleChoose: '7',
      totalTrueFalse: '5',
      marksPerQuestion: '2',
      passMarks: '30',
      negativeMarking: '-1',
    },
  ];

  const staticCourseData = [
    { id: 1, name: 'Mathematics' },
    { id: 2, name: 'Science' },
    { id: 3, name: 'History' },
    { id: 4, name: 'Geography' },
    { id: 5, name: 'Literature' },
  ];

  const [quizData, setQuizData] = useState(staticQuizData);
  const [filteredData, setFilteredData] = useState(staticQuizData);

  const handleAddQuiz = () => {
    setFormData({
      viewResult: false,
      setTime: false,
      reAttempt: false,
      date: '',
      startTime: '',
      endTime: '',
      courseName: '',
      quizName: '',
      maxAttempts: '',
      duration: '',
      noOfQuestions: '',
      totalSingleChoose: '',
      totalMultipleChoose: '',
      totalTrueFalse: '',
      marksPerQuestion: '',
      passMarks: '',
      negativeMarking: '0',
    });
    setShowAddQuizModal(true);
  };

  const handleEdit = (quiz) => {
    setSelectedQuiz({ quizId: quiz.quizId, quizName: quiz.quizName });
    setFormData({
      viewResult: quiz.viewResult,
      setTime: quiz.setTime,
      reAttempt: quiz.reAttempt,
      date: quiz.date,
      startTime: quiz.startTime,
      endTime: quiz.endTime,
      courseName: quiz.courseName,
      quizName: quiz.quizName,
      maxAttempts: quiz.maxAttempts,
      duration: quiz.duration,
      noOfQuestions: quiz.numberOfQuestions,
      totalSingleChoose: quiz.totalSingleChoose,
      totalMultipleChoose: quiz.totalMultipleChoose,
      totalTrueFalse: quiz.totalTrueFalse,
      marksPerQuestion: quiz.marksPerQuestion,
      passMarks: quiz.passMarks,
      negativeMarking: quiz.negativeMarking,
    });
    setShowEditQuizModal(true);
  };

  const handleView = (quiz) => {
    setSelectedQuiz({ quizId: quiz.quizId, quizName: quiz.quizName });
    setFormData({
      viewResult: quiz.viewResult,
      setTime: quiz.setTime,
      reAttempt: quiz.reAttempt,
      date: quiz.date,
      startTime: quiz.startTime,
      endTime: quiz.endTime,
      courseName: quiz.courseName,
      quizName: quiz.quizName,
      maxAttempts: quiz.maxAttempts,
      duration: quiz.duration,
      noOfQuestions: quiz.numberOfQuestions,
      totalSingleChoose: quiz.totalSingleChoose,
      totalMultipleChoose: quiz.totalMultipleChoose,
      totalTrueFalse: quiz.totalTrueFalse,
      marksPerQuestion: quiz.marksPerQuestion,
      passMarks: quiz.passMarks,
      negativeMarking: quiz.negativeMarking,
    });
    setShowViewQuizModal(true);
  };

  const handleShowDeleteModal = (quizId, quizName) => {
    setSelectedQuiz({ quizId, quizName });
    setShowDeleteModal(true);
  };

  const handleDelete = () => {
    setQuizData((prevQuizzes) =>
      prevQuizzes.filter((quiz) => quiz.quizId !== selectedQuiz.quizId)
    );
    setSnackbarMessage(`Quiz "${selectedQuiz.quizName}" deleted successfully!`);
    setSnackbarSeverity('success');
    setOpenSnackbar(true);
    setShowDeleteModal(false);
    setShowSuccessModal(true);
    setSuccessModalType('delete');
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const validateForm = () => {
    const {
      courseName,
      quizName,
      maxAttempts,
      duration,
      noOfQuestions,
      marksPerQuestion,
      passMarks,
      totalSingleChoose,
      totalMultipleChoose,
      totalTrueFalse,
      setTime,
      date,
      startTime,
      endTime,
    } = formData;
    if (!courseName || !quizName || !maxAttempts || !duration || !noOfQuestions || !marksPerQuestion || !passMarks) {
      return { valid: false, message: 'Please fill all required fields' };
    }
    const totalQuestions =
      (parseInt(totalSingleChoose) || 0) +
      (parseInt(totalMultipleChoose) || 0) +
      (parseInt(totalTrueFalse) || 0);
    if (totalQuestions > parseInt(noOfQuestions)) {
      return { valid: false, message: 'Total question types cannot exceed Number of Questions' };
    }
    if (setTime && (!date || !startTime || !endTime)) {
      return { valid: false, message: 'Please fill all time-related fields' };
    }
    return { valid: true };
  };

  const handleSave = () => {
    const validation = validateForm();
    if (validation.valid) {
      const newQuiz = {
        quizId: quizData.length + 1,
        ...formData,
        numberOfQuestions: formData.noOfQuestions,
      };
      setQuizData([...quizData, newQuiz]);
      setShowAddQuizModal(false);
      setShowSuccessModal(true);
      setSuccessModalType('add');
      setFormData({
        viewResult: false,
        setTime: false,
        reAttempt: false,
        date: '',
        startTime: '',
        endTime: '',
        courseName: '',
        quizName: '',
        maxAttempts: '',
        duration: '',
        noOfQuestions: '',
        totalSingleChoose: '',
        totalMultipleChoose: '',
        totalTrueFalse: '',
        marksPerQuestion: '',
        passMarks: '',
        negativeMarking: '0',
      });
      setSnackbarMessage('Quiz added successfully!');
      setSnackbarSeverity('success');
      setOpenSnackbar(true);
    } else {
      setSnackbarMessage(validation.message);
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    }
  };

  const handleUpdate = () => {
    const validation = validateForm();
    if (validation.valid) {
      const updatedQuizzes = quizData.map((quiz) =>
        quiz.quizId === selectedQuiz.quizId
          ? { ...quiz, ...formData, numberOfQuestions: formData.noOfQuestions }
          : quiz
      );
      setQuizData(updatedQuizzes);
      setShowEditQuizModal(false);
      setShowSuccessModal(true);
      setSuccessModalType('edit');
      setFormData({
        viewResult: false,
        setTime: false,
        reAttempt: false,
        date: '',
        startTime: '',
        endTime: '',
        courseName: '',
        quizName: '',
        maxAttempts: '',
        duration: '',
        noOfQuestions: '',
        totalSingleChoose: '',
        totalMultipleChoose: '',
        totalTrueFalse: '',
        marksPerQuestion: '',
        passMarks: '',
        negativeMarking: '0',
      });
      setSnackbarMessage('Quiz updated successfully!');
      setSnackbarSeverity('success');
      setOpenSnackbar(true);
    } else {
      setSnackbarMessage(validation.message);
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    }
  };

  const handleCancel = () => {
    setShowEditQuizModal(false);
    setShowViewQuizModal(false);
    setShowAddQuizModal(false);
    setFormData({
      viewResult: false,
      setTime: false,
      reAttempt: false,
      date: '',
      startTime: '',
      endTime: '',
      courseName: '',
      quizName: '',
      maxAttempts: '',
      duration: '',
      noOfQuestions: '',
      totalSingleChoose: '',
      totalMultipleChoose: '',
      totalTrueFalse: '',
      marksPerQuestion: '',
      passMarks: '',
      negativeMarking: '0',
    });
  };

  const handleReset = () => {
    setFormData({
      viewResult: false,
      setTime: false,
      reAttempt: false,
      date: '',
      startTime: '',
      endTime: '',
      courseName: '',
      quizName: '',
      maxAttempts: '',
      duration: '',
      noOfQuestions: '',
      totalSingleChoose: '',
      totalMultipleChoose: '',
      totalTrueFalse: '',
      marksPerQuestion: '',
      passMarks: '',
      negativeMarking: '0',
    });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  useEffect(() => {
    setFilteredData(
      quizData.filter((quiz) =>
        Object.values(quiz).some((value) =>
          value.toString().toLowerCase().includes(searchTerm.toLowerCase())
        )
      )
    );
  }, [searchTerm, quizData]);

  const paginatedData = filteredData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  return (
    <Container sx={{ maxWidth: '100%', boxSizing: 'border-box' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: 1,
          p: 2,
          boxShadow: 'none',
          maxWidth: '100%',
          boxSizing: 'border-box',
        }}
      >
        <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', gap: 2 }}>
           <TextField
            variant="outlined"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon
                    sx={{
                      color: theme.palette.primary.main,
                      marginLeft: 1.5,
                      fontSize: 24,
                    }}
                  />
                </InputAdornment>
              ),
              endAdornment: searchTerm && (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={() => setSearchTerm('')}
                    sx={{
                      color: "grey",
                      marginRight: 1,
                    }}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
              sx: {
                borderRadius: '30px',
                backgroundColor: theme.palette.mode === 'dark'
                  ? 'rgba(255, 255, 255, 0.15)'
                  : 'rgba(255, 255, 255, 1)',
                boxShadow: theme.palette.mode === 'dark'
                  ? '0 2px 8px rgba(0, 0, 0, 0.3)'
                  : '0 2px 8px rgba(0, 0, 0, 0.1)',
                '& .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)'}`,
                },
                '&:hover': {
                  backgroundColor: theme.palette.mode === 'dark'
                    ? 'rgba(255, 255, 255, 0.2)'
                    : 'rgba(240, 240, 240, 1)',
                  boxShadow: theme.palette.mode === 'dark'
                    ? '0 2px 12px rgba(0, 0, 0, 0.4)'
                    : '0 2px 12px rgba(0, 0, 0, 0.15)',
                },
                '&.Mui-focused': {
                  backgroundColor: theme.palette.mode === 'dark'
                    ? 'rgba(255, 255, 255, 0.25)'
                    : 'rgba(255, 255, 255, 1)',
                  boxShadow: `0 0 0 3px ${theme.palette.primary.main}20`,
                  '& .MuiOutlinedInput-notchedOutline': {
                    border: `2px solid ${theme.palette.primary.main}`,
                  },
                },
                paddingLeft: 1.5,
                height: '50px',
                transition: 'all 0.3s ease',
              },
            }}
            sx={{
              width: 350,
              maxWidth: '100%',
              '& .MuiInputBase-input': {
                padding: '10px 14px',
                color: theme.palette.text.primary,
                fontWeight: 500,
              },
            }}
          />
          <Button
            variant="contained"
            onClick={() => { navigate("/add-managecoursequiz") }}
            sx={{
              ml: 2,
              width: '160px',
              borderRadius: '10px',
              height: '50px',
              padding: '10px 0',
              fontWeight: 'bold',
              backgroundColor: theme.palette.primary.main,
              '&:hover': { backgroundColor: theme.palette.primary.dark },
            }}
            startIcon={<AddIcon />}
          >
            Add Quiz
          </Button>
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <IconButton
            onClick={() => setShowUserGuideModal(true)}
            sx={{
              width: 60,
              height: 60,
              borderRadius: '50%',
              minWidth: 0, // Remove MUI's default padding
            }}
          >
            <InfoOutlineIcon sx={{ fontSize: 30 }} />
          </IconButton>
        </Box>
      </Box>
      <Paper
        elevation={3}
        sx={{
          paddingBottom: 0,
          maxWidth: '100%',
          boxSizing: 'border-box',
          mx: 'auto',
          backgroundColor: theme.palette.background.paper,
          borderRadius: '16px',
        }}
      >
        <CustomTableScrollbar sx={{ width: '100%', overflowX: 'auto' }}>
          <TableContainer sx={{ width: '100%', borderRadius: '16px' }}>
            <Table
              sx={{
                '& .MuiTableHead-root .MuiTableCell-root': {
                  fontWeight: 'bold',
                  backgroundColor: theme.palette.primary.main,
                  color: 'white',
                  fontSize: '1.1rem',
                },
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell>S.No</TableCell>
                  <TableCell>Quiz Name</TableCell>
                  <TableCell>Course</TableCell>
                  <TableCell>Duration</TableCell>
                  <TableCell>Number of Questions</TableCell>
                  <TableCell align="center">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedData.length > 0 ? (
                  paginatedData.map((quiz, index) => (
                    <TableRow
                      key={quiz.quizId}
                      sx={{
                        backgroundColor: index % 2 === 0 ? theme.palette.background.paper : theme.palette.background.paper,
                        '&:hover': {
                          backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        },
                      }}
                    >
                      <TableCell sx={{ fontSize: '1rem' }}>{(page - 1) * rowsPerPage + index + 1}</TableCell>
                      <TableCell sx={{ fontSize: '1rem' }}>{quiz.quizName}</TableCell>
                      <TableCell sx={{ fontSize: '1rem' }}>{quiz.courseName}</TableCell>
                      <TableCell sx={{ fontSize: '1rem' }}>{quiz.duration} mins</TableCell>
                      <TableCell sx={{ fontSize: '1rem' }}>{quiz.numberOfQuestions}</TableCell>
                      <TableCell align="center">
                        <IconButton
                          onClick={() => navigate(`/edit-managecoursequiz/${quiz.quizId}`)}
                          sx={{
                            color: theme.palette.primary.light,
                            '&:hover': {
                              backgroundColor: 'rgba(0, 0, 0, 0.04)',
                            },
                          }}
                        >
                          <EditIcon />
                        </IconButton>
                        <IconButton
                          color="error"
                          onClick={() => handleShowDeleteModal(quiz.quizId, quiz.quizName)}
                          sx={{
                            '&:hover': {
                              backgroundColor: 'rgba(0, 0, 0, 0.04)',
                            },
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow sx={{
                    backgroundColor: theme.palette.background.paper,
                    '&:hover': {
                      backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    },
                  }}>
                    <TableCell colSpan={6} align="center" sx={{ fontSize: '1rem', padding: '20px', wordSpacing: 7 }}>
                      No  Data Found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTableScrollbar>
      </Paper>

      {filteredData.length > 0 && (
        <Box
          sx={{
            maxWidth: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mt: 1,
            p: 2,
            mx: 'auto',
            pt: 2,
          }}
        >
          <Typography variant="body2" color={theme.palette.primary.main}>
            Page <strong>{page}</strong> of <strong>{Math.ceil(filteredData.length / rowsPerPage)}</strong>
          </Typography>
          <Stack direction="row" alignItems="center" spacing={1}>
            <IconButton
              onClick={() => handleChangePage(null, page - 1)}
              disabled={page === 1}
              sx={{
                color: theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
                '&.Mui-disabled': {
                  opacity: 0.3,
                },
                borderRadius: '50%',
                width: '36px',
                height: '36px',
              }}
            >
              <ChevronLeft />
            </IconButton>
            {[...Array(Math.ceil(filteredData.length / rowsPerPage))].map((_, index) => (
              <IconButton
                key={index + 1}
                onClick={() => handleChangePage(null, index + 1)}
                sx={{
                  width: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  backgroundColor: page === index + 1 ? theme.palette.primary.main : 'transparent',
                  color: page === index + 1 ? theme.palette.primary.contrastText : theme.palette.text.primary,
                  '&:hover': {
                    backgroundColor: page === index + 1 ? theme.palette.primary.dark : theme.palette.action.hover,
                  },
                }}
              >
                {index + 1}
              </IconButton>
            ))}
            <IconButton
              onClick={() => handleChangePage(null, page + 1)}
              disabled={page >= Math.ceil(filteredData.length / rowsPerPage)}
              sx={{
                color: theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
                '&.Mui-disabled': {
                  opacity: 0.3,
                },
                borderRadius: '50%',
                width: '36px',
                height: '36px',
              }}
            >
              <ChevronRight />
            </IconButton>
            <FormControl size="small" sx={{ minWidth: 100, ml: 1 }}>
              <InputLabel id="rows-per-page-label" sx={{ color: theme.palette.text.primary }}>
                Rows
              </InputLabel>
              <Select
                labelId="rows-per-page-label"
                value={rowsPerPage}
                onChange={handleChangeRowsPerPage}
                label="Rows"
                sx={{
                  height: '36px',
                  color: theme.palette.text.primary,
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                {rowsPerPageOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Box>
      )}

      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      {/* Delete Modal */}
      <Modal
        open={showDeleteModal}
        onClose={handleCloseDeleteModal}
        BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: '16px',
            boxShadow: 24,
            overflow: 'hidden',
            maxHeight: '80vh',
          }}
        >
          <Box
            sx={{
              backgroundColor: theme.palette.primary.main,
              padding: '12px 16px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Delete Confirmation ⚠️
            </Typography>
            <IconButton onClick={handleCloseDeleteModal} sx={{ color: '#fff' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ maxHeight: 'calc(80vh - 64px)', overflowY: 'auto', padding: '20px' }}>
            <Typography sx={{ mb: 2 }}>
              Are you sure you want to delete the quiz "{selectedQuiz.quizName}"?
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
              <Button
                variant="outlined"
                onClick={handleCloseDeleteModal}
                sx={{ mr: 1 }}
               data-app-cancel="true">
                Cancel
              </Button>
              <Button
                variant="contained"
                color="error"
                onClick={handleDelete}
              >
                Yes, Delete
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* Success Modal */}
      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: '16px',
            boxShadow: 24,
            overflow: 'hidden',
            maxHeight: '80vh',
          }}
        >
          <Box
            sx={{
              backgroundColor: theme.palette.primary.main,
              padding: '12px 16px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>
              {successModalType === 'add' ? 'Quiz Added ✅' : successModalType === 'edit' ? 'Quiz Updated ✅' : 'Quiz Deleted ✅'}
            </Typography>
            <IconButton onClick={() => setShowSuccessModal(false)} sx={{ color: '#fff' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ maxHeight: 'calc(80vh - 64px)', overflowY: 'auto', padding: '20px' }}>
            <Typography sx={{ mb: 2 }}>
              {successModalType === 'add' ? 'Quiz added successfully.' : successModalType === 'edit' ? 'Quiz updated successfully.' : 'Quiz deleted successfully.'}
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
              <Button
                variant="contained"
                onClick={() => setShowSuccessModal(false)}
                sx={{
                  backgroundColor: theme.palette.primary.main,
                  '&:hover': { backgroundColor: theme.palette.primary.dark },
                }}
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* Add Quiz Modal */}
      <Modal
        open={showAddQuizModal}
        onClose={handleCancel}
        BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
      >
        <CustomTableScrollbar
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 700,
            bgcolor: 'background.paper',
            borderRadius: '16px',
            boxShadow: 24,
            overflow: 'hidden',
            maxHeight: '90vh',
          }}
        >
          <Box
            sx={{
              backgroundColor: theme.palette.primary.main,
              padding: '12px 16px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Add Course Quiz
            </Typography>
            <IconButton onClick={handleCancel} sx={{ color: '#fff' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ maxHeight: 'calc(80vh - 64px)', overflowY: 'auto', padding: '20px' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <FormControlLabel
                control={<Checkbox name="viewResult" checked={formData.viewResult} onChange={handleChange} />}
                label="View Result"
              />
              <FormControlLabel
                control={<Checkbox name="setTime" checked={formData.setTime} onChange={handleChange} />}
                label="Set Time"
              />
              {formData.setTime && (
                <>
                  <TextField
                    label="Date"
                    type="date"
                    variant="outlined"
                    fullWidth
                    name="date"
                    value={formData.date}
                    onChange={handleChange}
                    required
                    InputLabelProps={{ shrink: true }}
                    sx={{
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.text.primary,
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.primary.main,
                      },
                      '& .MuiInputLabel-root': {
                        color: theme.palette.text.primary,
                      },
                      '& .MuiInputLabel-root.Mui-focused': {
                        color: theme.palette.primary.main,
                      },
                    }}
                  />
                  <TextField
                    label="Start Time"
                    type="time"
                    variant="outlined"
                    fullWidth
                    name="startTime"
                    value={formData.startTime}
                    onChange={handleChange}
                    required
                    InputLabelProps={{ shrink: true }}
                    sx={{
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.text.primary,
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.primary.main,
                      },
                      '& .MuiInputLabel-root': {
                        color: theme.palette.text.primary,
                      },
                      '& .MuiInputLabel-root.Mui-focused': {
                        color: theme.palette.primary.main,
                      },
                    }}
                  />
                  <TextField
                    label="End Time"
                    type="time"
                    variant="outlined"
                    fullWidth
                    name="endTime"
                    value={formData.endTime}
                    onChange={handleChange}
                    required
                    InputLabelProps={{ shrink: true }}
                    sx={{
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.text.primary,
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.primary.main,
                      },
                      '& .MuiInputLabel-root': {
                        color: theme.palette.text.primary,
                      },
                      '& .MuiInputLabel-root.Mui-focused': {
                        color: theme.palette.primary.main,
                      },
                    }}
                  />
                </>
              )}
              <Box sx={{ display: 'flex', gap: 2 }}>
                <FormControl sx={{ width: 300, maxWidth: '100%' }} required>
                  <InputLabel id="courseName-label" sx={{ color: theme.palette.text.primary, '&.Mui-focused': { color: theme.palette.primary.main } }}>
                    Course Name
                  </InputLabel>
                  <Select
                    labelId="courseName-label"
                    name="courseName"
                    value={formData.courseName}
                    label="Course Name"
                    onChange={handleChange}
                    sx={{
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.text.primary,
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.primary.main,
                      },
                    }}
                  >
                    <MenuItem value="">
                      <em>Select a course</em>
                    </MenuItem>
                    {staticCourseData.map((course) => (
                      <MenuItem key={course.id} value={course.name}>
                        {course.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <TextField
                  label="Quiz Name"
                  variant="outlined"
                  name="quizName"
                  value={formData.quizName}
                  onChange={handleChange}
                  required
                  sx={{
                    width: 300,
                    maxWidth: '100%',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.text.primary,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.primary.main,
                    },
                    '& .MuiInputLabel-root': {
                      color: theme.palette.text.primary,
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      color: theme.palette.primary.main,
                    },
                  }}
                />
              </Box>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField
                  label="Maximum Attempts"
                  variant="outlined"
                  type="number"
                  name="maxAttempts"
                  value={formData.maxAttempts}
                  onChange={handleChange}
                  required
                  sx={{
                    width: 300,
                    maxWidth: '100%',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.text.primary,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.primary.main,
                    },
                    '& .MuiInputLabel-root': {
                      color: theme.palette.text.primary,
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      color: theme.palette.primary.main,
                    },
                  }}
                />
                <TextField
                  label="Duration (minutes)"
                  variant="outlined"
                  type="number"
                  name="duration"
                  value={formData.duration}
                  onChange={handleChange}
                  required
                  sx={{
                    width: 300,
                    maxWidth: '100%',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.text.primary,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.primary.main,
                    },
                    '& .MuiInputLabel-root': {
                      color: theme.palette.text.primary,
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      color: theme.palette.primary.main,
                    },
                  }}
                />
              </Box>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField
                  label="Number of Questions"
                  variant="outlined"
                  type="number"
                  name="noOfQuestions"
                  value={formData.noOfQuestions}
                  onChange={handleChange}
                  required
                  sx={{
                    width: 300,
                    maxWidth: '100%',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.text.primary,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.primary.main,
                    },
                    '& .MuiInputLabel-root': {
                      color: theme.palette.text.primary,
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      color: theme.palette.primary.main,
                    },
                  }}
                />
                <TextField
                  label="Total Single Choose Questions"
                  variant="outlined"
                  type="number"
                  name="totalSingleChoose"
                  value={formData.totalSingleChoose}
                  onChange={handleChange}
                  sx={{
                    width: 300,
                    maxWidth: '100%',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.text.primary,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.primary.main,
                    },
                    '& .MuiInputLabel-root': {
                      color: theme.palette.text.primary,
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      color: theme.palette.primary.main,
                    },
                  }}
                />
              </Box>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField
                  label="Total Multiple Choose Questions"
                  variant="outlined"
                  type="number"
                  name="totalMultipleChoose"
                  value={formData.totalMultipleChoose}
                  onChange={handleChange}
                  sx={{
                    width: 300,
                    maxWidth: '100%',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.text.primary,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.primary.main,
                    },
                    '& .MuiInputLabel-root': {
                      color: theme.palette.text.primary,
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      color: theme.palette.primary.main,
                    },
                  }}
                />
                <TextField
                  label="Total True and False Questions"
                  variant="outlined"
                  type="number"
                  name="totalTrueFalse"
                  value={formData.totalTrueFalse}
                  onChange={handleChange}
                  sx={{
                    width: 300,
                    maxWidth: '100%',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.text.primary,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.primary.main,
                    },
                    '& .MuiInputLabel-root': {
                      color: theme.palette.text.primary,
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      color: theme.palette.primary.main,
                    },
                  }}
                />
              </Box>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField
                  label="Marks Per Question"
                  variant="outlined"
                  type="number"
                  name="marksPerQuestion"
                  value={formData.marksPerQuestion}
                  onChange={handleChange}
                  required
                  sx={{
                    width: 300,
                    maxWidth: '100%',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.text.primary,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.primary.main,
                    },
                    '& .MuiInputLabel-root': {
                      color: theme.palette.text.primary,
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      color: theme.palette.primary.main,
                    },
                  }}
                />
                <TextField
                  label="Pass Marks"
                  variant="outlined"
                  type="number"
                  name="passMarks"
                  value={formData.passMarks}
                  onChange={handleChange}
                  required
                  sx={{
                    width: 300,
                    maxWidth: '100%',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.text.primary,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.primary.main,
                    },
                    '& .MuiInputLabel-root': {
                      color: theme.palette.text.primary,
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      color: theme.palette.primary.main,
                    },
                  }}
                />
              </Box>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <FormControl sx={{ width: 300, maxWidth: '100%' }}>
                  <InputLabel id="negativeMarking-label" sx={{ color: theme.palette.text.primary, '&.Mui-focused': { color: theme.palette.primary.main } }}>
                    Negative Marking
                  </InputLabel>
                  <Select
                    labelId="negativeMarking-label"
                    name="negativeMarking"
                    value={formData.negativeMarking}
                    label="Negative Marking"
                    onChange={handleChange}
                    sx={{
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.text.primary,
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.primary.main,
                      },
                    }}
                  >
                    <MenuItem value="0">0</MenuItem>
                    <MenuItem value="-1">-1</MenuItem>
                  </Select>
                </FormControl>
                <FormControlLabel
                  control={<Checkbox name="reAttempt" checked={formData.reAttempt} onChange={handleChange} />}
                  label="Re-attempt"
                />
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                <Tooltip
                  title={
                    !formData.courseName
                      ? 'Select Course'
                      : !formData.quizName
                        ? 'Enter Quiz Name'
                        : !formData.maxAttempts
                          ? 'Enter Maximum Attempts'
                          : !formData.duration
                            ? 'Enter Duration'
                            : !formData.noOfQuestions
                              ? 'Enter Number of Questions'
                              : !formData.marksPerQuestion
                                ? 'Enter Marks Per Question'
                                : !formData.passMarks
                                  ? 'Enter Pass Marks'
                                  : formData.setTime && (!formData.date || !formData.startTime || !formData.endTime)
                                    ? 'Fill all time-related fields'
                                    : (parseInt(formData.totalSingleChoose) || 0) +
                                      (parseInt(formData.totalMultipleChoose) || 0) +
                                      (parseInt(formData.totalTrueFalse) || 0) >
                                      parseInt(formData.noOfQuestions)
                                      ? 'Total question types cannot exceed Number of Questions'
                                      : ''
                  }
                  arrow
                >
                  <span>
                    <Button
                      variant="contained"
                      onClick={handleSave}
                      sx={{
                        mr: 2,
                        backgroundColor: theme.palette.primary.main,
                        '&:hover': { backgroundColor: theme.palette.primary.dark },
                      }}
                      disabled={
                        !formData.courseName ||
                        !formData.quizName ||
                        !formData.maxAttempts ||
                        !formData.duration ||
                        !formData.noOfQuestions ||
                        !formData.marksPerQuestion ||
                        !formData.passMarks ||
                        (formData.setTime && (!formData.date || !formData.startTime || !formData.endTime)) ||
                        (parseInt(formData.totalSingleChoose) || 0) +
                        (parseInt(formData.totalMultipleChoose) || 0) +
                        (parseInt(formData.totalTrueFalse) || 0) >
                        parseInt(formData.noOfQuestions)
                      }
                    >
                      SAVE
                    </Button>
                  </span>
                </Tooltip>
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleReset}
                  sx={{ mr: 2 }}
                >
                  RESET
                </Button>

              </Box>
            </Box>
          </Box>
        </CustomTableScrollbar>
      </Modal>

      {/* Edit Quiz Modal */}
      <Modal
        open={showEditQuizModal}
        onClose={handleCancel}
        BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
      >
        <CustomTableScrollbar
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 700,
            bgcolor: 'background.paper',
            borderRadius: '16px',
            boxShadow: 24,
            overflow: 'hidden',
            maxHeight: '90vh',
          }}
        >
          <Box
            sx={{
              backgroundColor: theme.palette.primary.main,
              padding: '12px 16px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Edit Course Quiz
            </Typography>
            <IconButton onClick={handleCancel} sx={{ color: '#fff' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ maxHeight: 'calc(80vh - 64px)', overflowY: 'auto', padding: '20px' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <FormControlLabel
                control={<Checkbox name="viewResult" checked={formData.viewResult} onChange={handleChange} />}
                label="View Result"
              />
              <FormControlLabel
                control={<Checkbox name="setTime" checked={formData.setTime} onChange={handleChange} />}
                label="Set Time"
              />
              {formData.setTime && (
                <>
                  <TextField
                    label="Date"
                    type="date"
                    variant="outlined"
                    fullWidth
                    name="date"
                    value={formData.date}
                    onChange={handleChange}
                    required
                    InputLabelProps={{ shrink: true }}
                    sx={{
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.text.primary,
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.primary.main,
                      },
                      '& .MuiInputLabel-root': {
                        color: theme.palette.text.primary,
                      },
                      '& .MuiInputLabel-root.Mui-focused': {
                        color: theme.palette.primary.main,
                      },
                    }}
                  />
                  <TextField
                    label="Start Time"
                    type="time"
                    variant="outlined"
                    fullWidth
                    name="startTime"
                    value={formData.startTime}
                    onChange={handleChange}
                    required
                    InputLabelProps={{ shrink: true }}
                    sx={{
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.text.primary,
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.primary.main,
                      },
                      '& .MuiInputLabel-root': {
                        color: theme.palette.text.primary,
                      },
                      '& .MuiInputLabel-root.Mui-focused': {
                        color: theme.palette.primary.main,
                      },
                    }}
                  />
                  <TextField
                    label="End Time"
                    type="time"
                    variant="outlined"
                    fullWidth
                    name="endTime"
                    value={formData.endTime}
                    onChange={handleChange}
                    required
                    InputLabelProps={{ shrink: true }}
                    sx={{
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.text.primary,
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.primary.main,
                      },
                      '& .MuiInputLabel-root': {
                        color: theme.palette.text.primary,
                      },
                      '& .MuiInputLabel-root.Mui-focused': {
                        color: theme.palette.primary.main,
                      },
                    }}
                  />
                </>
              )}
              <Box sx={{ display: 'flex', gap: 2 }}>
                <FormControl sx={{ width: 300, maxWidth: '100%' }} required>
                  <InputLabel id="courseName-label" sx={{ color: theme.palette.text.primary, '&.Mui-focused': { color: theme.palette.primary.main } }}>
                    Course Name
                  </InputLabel>
                  <Select
                    labelId="courseName-label"
                    name="courseName"
                    value={formData.courseName}
                    label="Course Name"
                    onChange={handleChange}
                    sx={{
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.text.primary,
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.primary.main,
                      },
                    }}
                  >
                    <MenuItem value="">
                      <em>Select a course</em>
                    </MenuItem>
                    {staticCourseData.map((course) => (
                      <MenuItem key={course.id} value={course.name}>
                        {course.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <TextField
                  label="Quiz Name"
                  variant="outlined"
                  name="quizName"
                  value={formData.quizName}
                  onChange={handleChange}
                  required
                  sx={{
                    width: 300,
                    maxWidth: '100%',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.text.primary,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.primary.main,
                    },
                    '& .MuiInputLabel-root': {
                      color: theme.palette.text.primary,
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      color: theme.palette.primary.main,
                    },
                  }}
                />
              </Box>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField
                  label="Maximum Attempts"
                  variant="outlined"
                  type="number"
                  name="maxAttempts"
                  value={formData.maxAttempts}
                  onChange={handleChange}
                  required
                  sx={{
                    width: 300,
                    maxWidth: '100%',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.text.primary,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.primary.main,
                    },
                    '& .MuiInputLabel-root': {
                      color: theme.palette.text.primary,
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      color: theme.palette.primary.main,
                    },
                  }}
                />
                <TextField
                  label="Duration (minutes)"
                  variant="outlined"
                  type="number"
                  name="duration"
                  value={formData.duration}
                  onChange={handleChange}
                  required
                  sx={{
                    width: 300,
                    maxWidth: '100%',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.text.primary,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.primary.main,
                    },
                    '& .MuiInputLabel-root': {
                      color: theme.palette.text.primary,
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      color: theme.palette.primary.main,
                    },
                  }}
                />
              </Box>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField
                  label="Number of Questions"
                  variant="outlined"
                  type="number"
                  name="noOfQuestions"
                  value={formData.noOfQuestions}
                  onChange={handleChange}
                  required
                  sx={{
                    width: 300,
                    maxWidth: '100%',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.text.primary,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.primary.main,
                    },
                    '& .MuiInputLabel-root': {
                      color: theme.palette.text.primary,
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      color: theme.palette.primary.main,
                    },
                  }}
                />
                <TextField
                  label="Total Single Choose Questions"
                  variant="outlined"
                  type="number"
                  name="totalSingleChoose"
                  value={formData.totalSingleChoose}
                  onChange={handleChange}
                  sx={{
                    width: 300,
                    maxWidth: '100%',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.text.primary,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.primary.main,
                    },
                    '& .MuiInputLabel-root': {
                      color: theme.palette.text.primary,
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      color: theme.palette.primary.main,
                    },
                  }}
                />
              </Box>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField
                  label="Total Multiple Choose Questions"
                  variant="outlined"
                  type="number"
                  name="totalMultipleChoose"
                  value={formData.totalMultipleChoose}
                  onChange={handleChange}
                  sx={{
                    width: 300,
                    maxWidth: '100%',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.text.primary,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.primary.main,
                    },
                    '& .MuiInputLabel-root': {
                      color: theme.palette.text.primary,
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      color: theme.palette.primary.main,
                    },
                  }}
                />
                <TextField
                  label="Total True and False Questions"
                  variant="outlined"
                  type="number"
                  name="totalTrueFalse"
                  value={formData.totalTrueFalse}
                  onChange={handleChange}
                  sx={{
                    width: 300,
                    maxWidth: '100%',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.text.primary,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.primary.main,
                    },
                    '& .MuiInputLabel-root': {
                      color: theme.palette.text.primary,
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      color: theme.palette.primary.main,
                    },
                  }}
                />
              </Box>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField
                  label="Marks Per Question"
                  variant="outlined"
                  type="number"
                  name="marksPerQuestion"
                  value={formData.marksPerQuestion}
                  onChange={handleChange}
                  required
                  sx={{
                    width: 300,
                    maxWidth: '100%',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.text.primary,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.primary.main,
                    },
                    '& .MuiInputLabel-root': {
                      color: theme.palette.text.primary,
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      color: theme.palette.primary.main,
                    },
                  }}
                />
                <TextField
                  label="Pass Marks"
                  variant="outlined"
                  type="number"
                  name="passMarks"
                  value={formData.passMarks}
                  onChange={handleChange}
                  required
                  sx={{
                    width: 300,
                    maxWidth: '100%',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.text.primary,
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: theme.palette.primary.main,
                    },
                    '& .MuiInputLabel-root': {
                      color: theme.palette.text.primary,
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      color: theme.palette.primary.main,
                    },
                  }}
                />
              </Box>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <FormControl sx={{ width: 300, maxWidth: '100%' }}>
                  <InputLabel id="negativeMarking-label" sx={{ color: theme.palette.text.primary, '&.Mui-focused': { color: theme.palette.primary.main } }}>
                    Negative Marking
                  </InputLabel>
                  <Select
                    labelId="negativeMarking-label"
                    name="negativeMarking"
                    value={formData.negativeMarking}
                    label="Negative Marking"
                    onChange={handleChange}
                    sx={{
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.text.primary,
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme.palette.primary.main,
                      },
                    }}
                  >
                    <MenuItem value="0">0</MenuItem>
                    <MenuItem value="-1">-1</MenuItem>
                  </Select>
                </FormControl>
                <FormControlLabel
                  control={<Checkbox name="reAttempt" checked={formData.reAttempt} onChange={handleChange} />}
                  label="Re-attempt"
                />
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                <Tooltip
                  title={
                    !formData.courseName
                      ? 'Select Course'
                      : !formData.quizName
                        ? 'Enter Quiz Name'
                        : !formData.maxAttempts
                          ? 'Enter Maximum Attempts'
                          : !formData.duration
                            ? 'Enter Duration'
                            : !formData.noOfQuestions
                              ? 'Enter Number of Questions'
                              : !formData.marksPerQuestion
                                ? 'Enter Marks Per Question'
                                : !formData.passMarks
                                  ? 'Enter Pass Marks'
                                  : formData.setTime && (!formData.date || !formData.startTime || !formData.endTime)
                                    ? 'Fill all time-related fields'
                                    : (parseInt(formData.totalSingleChoose) || 0) +
                                      (parseInt(formData.totalMultipleChoose) || 0) +
                                      (parseInt(formData.totalTrueFalse) || 0) >
                                      parseInt(formData.noOfQuestions)
                                      ? 'Total question types cannot exceed Number of Questions'
                                      : ''
                  }
                  arrow
                >
                  <span>
                    <Button
                      variant="contained"
                      onClick={handleUpdate}
                      sx={{
                        mr: 2,
                        backgroundColor: theme.palette.primary.main,
                        '&:hover': { backgroundColor: theme.palette.primary.dark },
                      }}
                      disabled={
                        !formData.courseName ||
                        !formData.quizName ||
                        !formData.maxAttempts ||
                        !formData.duration ||
                        !formData.noOfQuestions ||
                        !formData.marksPerQuestion ||
                        !formData.passMarks ||
                        (formData.setTime && (!formData.date || !formData.startTime || !formData.endTime)) ||
                        (parseInt(formData.totalSingleChoose) || 0) +
                        (parseInt(formData.totalMultipleChoose) || 0) +
                        (parseInt(formData.totalTrueFalse) || 0) >
                        parseInt(formData.noOfQuestions)
                      }
                    >
                      UPDATE
                    </Button>
                  </span>
                </Tooltip>
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleCancel}
                >
                  CANCEL
                </Button>
              </Box>
            </Box>
          </Box>
        </CustomTableScrollbar>
      </Modal>
      <Modal
        open={showUserGuideModal}
        onClose={() => setShowUserGuideModal(false)}
        BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 800,
            bgcolor: 'background.paper',
            borderRadius: '16px',
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box
            sx={{
              backgroundColor: theme.palette.primary.main,
              padding: '12px 16px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              position: 'relative',
            }}
          >
            <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Course Quiz Management - For User Guide
            </Typography>
            <IconButton
              onClick={() => setShowUserGuideModal(false)}
              sx={{ color: '#fff', position: 'absolute', right: 14 }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Scrollable Content */}
         <CustomTableScrollbar sx={{ maxHeight: '70vh', overflowY: 'auto', padding: '20px' }}>
  {/* Section 1: Add Quiz */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mb: 1 }}
  >
    ➤ Follow these steps to add a new quiz:
  </Typography>
  <ul style={{ marginLeft: '20px', lineHeight: '1.8', cursor: 'pointer' }}>
    <li>
      Click the <strong>"Add Quiz"</strong> button at the top-right corner to open the Add Quiz form.
    </li>
    <li>
      In the add modal, enable <strong>"View Result"</strong> if users should be allowed to view their results after completing the quiz.
    </li>
    <li>
      In the add modal, enable <strong>"Set Time"</strong> to schedule the quiz. If selected, enter the <strong>Date</strong>, <strong>Start Time</strong>, and <strong>End Time</strong>.
    </li>
    <li>
      Enable <strong>"Re-attempt"</strong> to allow users to attempt the quiz multiple times.
    </li>
    <li>
      Select a <strong>Course Name</strong> from the dropdown menu.
    </li>
    <li>
      Enter the <strong>Quiz Name</strong>, <strong>Maximum Attempts</strong>, <strong>Duration</strong> (in minutes), <strong>Number of Questions</strong>, <strong>Marks Per Question</strong>, and <strong>Pass Marks</strong> in their respective fields.
    </li>
    <li>
      Optionally, specify the number of <strong>Single Choice</strong>, <strong>Multiple Choice</strong>, and <strong>True/False</strong> questions. Ensure their total does not exceed the Number of Questions.
    </li>
    <li>
      Select the <strong>Negative Marking</strong> value (0 or -1) from the dropdown menu.
    </li>
    <li>
      Before saving, carefully review all entered details to ensure accuracy.
    </li>
    <li>
      Click the <strong>"SAVE"</strong> button to create the quiz. A success message will confirm the action.
    </li>
    <li>
      To clear the form, click <strong>"RESET"</strong>, or click <strong>"CANCEL"</strong> to close the modal without saving.
    </li>
    <li>
      The newly created quiz will then appear in the <strong>Quiz List</strong> table.
    </li>
  </ul>
  <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
    ⚠️ Note: Course Name, Quiz Name, Maximum Attempts, Duration, Number of Questions, Marks Per Question, and Pass Marks are mandatory fields.
  </Typography>
  <Typography variant="body2" sx={{ mt: 1, color: theme.palette.text.primary }}>
    ⚠️ Note: If <strong>Set Time</strong> is enabled, Date, Start Time, and End Time are also required. The total number of Single Choice, Multiple Choice, and True/False questions must not exceed the Number of Questions.
  </Typography>

  {/* Section 2: Edit Quiz */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
  >
    ➤ Follow these steps to edit/Update an existing quiz:
  </Typography>
  <ul style={{ marginLeft: '20px', lineHeight: '1.8', cursor: 'pointer' }}>
    <li>
      Select the quiz record you want to update from the <strong>Quiz List</strong> table.
    </li>
    <li>
      Click the <strong>Edit</strong> icon (pencil) in the Action column to open the edit quiz form.
    </li>
    <li>
      In the edit modal, update the View Result, Set Time, Re-attempt, Date, Start Time, End Time, Course Name, Quiz Name, Maximum Attempts, Duration, Number of Questions, Single Choice, Multiple Choice, True/False counts, Marks Per Question, Pass Marks, or Negative Marking as required.
    </li>
    <li>
      Ensure all mandatory fields are completed and the total number of question types does not exceed the Number of Questions.
    </li>
    <li>
      Click the <strong>"UPDATE"</strong> button to save the changes. A success message will confirm the update.
    </li>
    <li>
      To clear the form, click <strong>"RESET"</strong>, or click <strong>"CANCEL"</strong> to close the modal without saving.
    </li>
  </ul>

  {/* Section 3: Delete Quiz */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
  >
    ➤ Follow these steps to delete a quiz:
  </Typography>
  <ul style={{ marginLeft: '20px', lineHeight: '1.8', cursor: 'pointer' }}>
    <li>
      Select the quiz record you want to delete from the <strong>Quiz List</strong> table.
    </li>
    <li>
      Click the <strong>Delete</strong> icon (trash) in the Action column.
    </li>
    <li>
      Confirm the deletion by clicking <strong>"Yes, Delete"</strong> in the confirmation modal.
    </li>
    <li>
      The quiz record will be removed from the list, and a success message will appear at the top of the page.
    </li>
  </ul>
  <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
    ⚠️ Note: Deleted quizzes cannot be recovered. Please proceed with caution.
  </Typography>

  {/* Section 4: Search Quizzes */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
  >
    ➤ Follow these steps to search for a quiz:
  </Typography>
  <ul style={{ marginLeft: '20px', lineHeight: '1.8', cursor: 'pointer' }}>
    <li>
      Use the search bar located at the top-left of the Quiz List table.
    </li>
    <li>
      Enter the Quiz Name, Course, Duration, Number of Questions, or other quiz-related details (or part of them) to filter the results.
    </li>
    <li>
      The table will automatically update to display matching quizzes.
    </li>
  </ul>

  {/* Section 5: Pagination */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
  >
    ➤ Follow these steps to navigate the quiz list:
  </Typography>
  <ul style={{ marginLeft: '20px', lineHeight: '1.8', cursor: 'pointer' }}>
    <li>
      Use the pagination controls at the bottom of the table to move through pages of quizzes.
    </li>
    <li>
      Click the left (<strong>&lt;</strong>) or right (<strong>&gt;</strong>) arrows to navigate between pages.
    </li>
    <li>
      Click on a specific page number to jump directly to that page.
    </li>
    <li>
      Change the number of rows displayed per page using the dropdown menu (for example, 5, 10, 25, or 50 rows).
    </li>
  </ul>
  <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
    ⚠️ Note: The table displays only the selected number of rows per page.
  </Typography>
</CustomTableScrollbar>

        </Box>
      </Modal>
    </Container>
  );
};

export default ManageCourseQuiz;